<div [class.c-tooltip--top]="location === 'top'" class="c-tooltip">
	<tvcore-icon name="question-circle"></tvcore-icon>

	<div class="c-tooltip__message">
		<ng-content></ng-content>
	</div>
</div>
